import { View } from '@fairygodboss/ui';
import React from 'react';

export default class Overlay extends React.PureComponent {
    componentDidMount() {
        document.querySelector('body').classList.add('overlay-open');
        if (this.props.drawerType === 'message') document.querySelector('body').classList.add('message-drawer');
    }

    componentWillUnmount() {
        document
            .querySelector('body')
            .classList.remove('overlay-open', 'message-drawer');
    }

    render() {
        const {
            children, cssClass, handleClose, type
        } = this.props;

        return (
            <View
                className={`component-Overlay ${type} ${cssClass}`}
                onClick={handleClose}
            >
                <style global jsx>
                    {`
                        .component-Overlay {
                            height: 100%;
                            width: 100vw;
                            position: fixed;
                            background-color: rgba(0, 0, 0, 0.7);
                            top: 0;
                            left: 0;
                            z-index: 200;
                        }
                        .component-Overlay.transparent {
                            left: 0;
                            background-color: rgba(0, 0, 0, 0);
                        }
                        @media screen and (min-width: 576px) {
                            .component-Overlay.messages-overlay {
                                display: none;
                            }
                        }
                        body.overlay-open,
                        body.message-drawer {
                            overflow: hidden !important;
                        }
                        @media screen and (min-width: 576px) {
                            body.overlay-open.message-drawer {
                                overflow: auto !important;
                            }
                        }
                    `}
                </style>
                {children}
            </View>
        );
    }
}
